module.exports = __webpack_public_path__ + "static/tree.d3496d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tree.png
// module id = 473
// module chunks = 180975309979847